<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          Quarter Configuration
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9> </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs2 class="pt-1">
                <span class="subtitle-1 font-weight-black lightblack--text"
                  >Start Date</span
                >
              </v-flex>
              <v-flex xs1 class="text-right pr-5 pt-2">
                :
              </v-flex>
              <v-flex xs6>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="start_date"
                      single-line
                      prepend-icon="event"
                      class="pt-0 mt-0"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    @input="menu = false"
                  ></v-date-picker>
                  <!-- <v-date-picker
                    v-model="start_date"
                    no-title
                    scrollable
                    :min="minDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(start_date)"
                      >OK</v-btn
                    >
                  </v-date-picker> -->
                </v-menu>
              </v-flex>
            </v-row>
          </v-flex>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs2 class="pt-2">
                <span class="subtitle-1 font-weight-black lightblack--text"
                  >End Date</span
                >
              </v-flex>
              <v-flex xs1 class="text-right pr-5 pt-2">
                :
              </v-flex>
              <v-flex xs6>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="end_date"
                      single-line
                      prepend-icon="event"
                      class="pt-0 mt-0"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="end_date" @input="menu2 = false" />
                </v-menu>
                <span
                  v-if="validationMessage != ''"
                  class="red--text caption"
                  >{{ validationMessage }}</span
                >
              </v-flex>
            </v-row>
          </v-flex>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs2 class="pt-3">
                <span class="subtitle-1 font-weight-black lightblack--text"
                  >Activate</span
                >
              </v-flex>
              <v-flex xs1 class="text-right pr-5 pt-3">
                :
              </v-flex>
              <v-flex xs6 class="pl-2 pt-0">
                <v-switch
                  v-model="isActive"
                  inset
                  color="primary"
                  class="pt-0"
                ></v-switch>
              </v-flex>
            </v-row>
          </v-flex>
        </v-card-text>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 class="mb-5 mr-3">
            <v-btn
              id="saveBtn"
              color="blue darken-2"
              class="white--text"
              block
              @click="save(items[0].id)"
              :disabled="isDisable"
            >
              Save
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      items: [],
      minDate: new Date().toISOString().slice(0, 10),
      start_date: '',
      isDisable: false,
      end_date: '',
      isActive: false,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      menu: false,
      validationMessage: '',
      menu2: false,
      active: false,
      breadcrumbs: [
        {
          text: 'Configuration',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Quarter',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      timeout: null
    };
  },
  mounted() {
    this.getData();
    this.dateCheck(this.start_date, this.end_date);
  },
  watch: {
    start_date(value) {
      this.dateCheck(value, this.end_date);
    },
    end_date(value) {
      this.dateCheck(this.start_date, value);
    }
  },
  methods: {
    dateCheck(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      let today = new Date();
      today.setHours(0, 0, 0);
      if (startDate < today) {
        this.validationMessage =
          'You have entered an invalid date. Please check again.';
        this.isDisable = true;
      } else {
        if (startDate > endDate) {
          this.validationMessage = 'Start Date must be earlier than End Date.';
          this.isDisable = true;
        } else {
          this.validationMessage = '';
          this.isDisable = false;
        }
      }
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      return this.$store
        .dispatch('configuration/getAll')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.start_date = this.items[0].start_date;
            this.end_date = this.items[0].end_date;
            this.isActive = this.items[0].is_active;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    save(id) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to update config quarter?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          this.items.map(item => {
            item.start_date = this.start_date;
            item.end_date = this.end_date;
            item.is_active = this.isActive;
          });
          this.$store
            .dispatch('configuration/updatePeriod', {
              id,
              payload: this.items[0]
            })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
